import CompareGroupPlansCalculator from './compare-group-plans-calculator'

export default CompareGroupPlansCalculator
